export default "__VITE_ASSET__dX059lpq__"